

import SpectraNG_Page_3_1 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_3_1.jpg";
import SpectraNG_Page_4_1 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_4_1.png";
import SpectraNG_Page_5_1 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_5_1.png";
import SpectraNG_Page_5_2 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_5_2.png";
import SpectraNG_Page_5_3 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_5_3.png";
import SpectraNG_Page_6_1 from "../../../../common/assets/images/Montronix/Video/SpectraNG_Page_6_1.png";



import { Ipoint2D } from "../../../../common/interfaces";

export const videoPointsSpectraNG: Ipoint2D[] = [
  {
    id: 1,
    top: "0.5rem",
    titletext:[""],
    left: "54%",
    title: "Решаемые задачи SpectraNG",
    title_short: "Решаемые задачи",
    content: [""],
    text: [""],
    list: [
      {
        title: "",
        quotes: [
          "Мониторинг инструмента (износ инструмента, поломка инструмента, отсутствие инструмента), в том числе диаметром менее 3 мм.",
          "Мониторинг столкновений.",
          "Измерение вибрации при обработке, вибрации корпуса станка, мощности и усилия при обработке для выявления технологических ошибок.",
          "Обнаружение микротрещин на режущих пластинах инструмента.",
          "Сильные колебания приспособлений (цанги, зажимы и т.д).",
          "Различия в материалах (микроотверстия, включения и т. д.).",
        ],
      },
    ],
  },
  {
    id: 2,
    top: "0.5rem",
    left: "40%",
    titletext:[""],
    title: "Эффект от применения SpectraNG",
    title_short: "Эффект от применения",
    content: [""],
    text: [
      "",
    ],
    list: [
      {
        title: "",
        quotes: [
          "Повышение качества обработки.",
          "Оптимизация процессов и режимов резания.",
          "Обнаружение износа компонентов машины на ранней стадии.",
          "Обнаружение дисбаланса инструмента или шпинделя и снижение нагрузки на оборудование.",
          "Выявление нежелательных отклонения от запланированного процесса обработки и минимизация процента брака.",
          "Своевременное выполнение профилактического обслуживания.",
        ],
      },
    ],
  },
  {
    id: 3,
    top: "0.5rem",
    left: "47%",
    titletext:[""],
    title: "Составные части системы",
    title_short: "Составные части",
    content: [SpectraNG_Page_3_1],
    text: ["Система мониторинга SpectraNG состоит из основных компонентов: процессорного блока Spectra, SensorHub -а, для подключения дополнительных типов датчиков, ПЛК интерфейса ЧПУ и SpectraHMI для управлении и визуалицзации процесса работы системы мониторинга."],
  },
  {
    id: 4,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Алгоритм работы",
    title_short: "Алгоритм работы",
    content: [SpectraNG_Page_4_1],
    text: [""],
  },
  {
    id: 5,
    top: "0.5rem",
    left: "54%",
    titletext:["Фиксированные пределы","Ступенчатые пределы","Плавающие пределы"],
    title: "Виды пределов Spectra NG",
    title_short: "Виды пределов",
    content: [SpectraNG_Page_5_1,SpectraNG_Page_5_2,SpectraNG_Page_5_3],
    text: ["При использовании метода фиксированных пределов система SpectraNG сравнивает сигналы датчиков до фиксированных предельных значений в течение всего цикла резания конкретного инструмента. Эти ограничения остаются неизменным в течение последовательных циклов резания этого инструмента.","При использовании ступенчатых пределов система SpectraNG делит сигнал датчика в течение одного цикла резки на несколько сегментов. Каждому сегменту назначается отдельный набор пределов. Такие пределы позволяют системе не реагировать на возросшую вибрацию вследствие ожидаемого ее роста.","При использовании плавающих пределов система SpectraNG отслеживает тенденции от цикла к циклу. Это достигается за счет использования информации из текущего цикла для корректировки пределов, применяемых к следующий. Метод плавающих пределов более чувствителен к краткосрочным событиям, чем фиксированный. Метод пределов. Например, использование плавающих пределов может улучшить обнаружение отсутствующих инструментов в многошпиндельные приложения."],
    
  },
  {
    id: 6,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Spectra-HMI",
    title_short: "Spectra-HMI",
    content: [SpectraNG_Page_6_1],
    text: [""],
    list: [
      {
        title: "",
        quotes: [
          "Специальное ПО визуализации процесса Spectra ™ -hmi является технически перспективным решением:",
          "Свободно конфигурируемая рабочая область с возможностью отображения информации с 12 датчиков;",
          "7 уровней доступа, защищенных паролем;",
          "Графическое изменение пределов мониторинга;",
          "Автономное воспроизведение процесса из файла-протокола с функциями фильтра;",
          "Независимость от операционной системы;",
          "Быстрая настройка параметров;",
          "(Мультиизменение, Быстрое изменение).",

        ],
      },
    ],
  },
  {
    id: 7,
    top: "0.5rem",
    left: "54%",
    title: "Технические характеристики SperctraNG",
    title_short: "Технические характеристики ",
    content: [""],
    titletext:[""],
    text: [""],
    table: {
      tableheads: [
        { width: "100%", content: "Классификация ШУ" },
      ],
      rows: [
        {
          tableText:[""],
          tableContent:[""],
          title: "IBU NG",
          showhead: false,
          columns: [
            [{content:["Размеры (ШxВxГ в мм)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["ок. 121 х 100 х 154"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Масса"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["около 1200 г"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Класс защиты"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP40"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Возможные интерфейсы"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["CNC I/O, Ethernet, MTX-Net, OPC,\nProfinet, Profibus, 2x USB,\nSensor, Service, HDMI"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Хранилище"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["32 ГБ SD-карты"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Температура окружающей среды"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Эксплуатация от -10 до 60°C /\n хранение от -20 до 70°C"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Влажность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["от 0 до 95 % без конденсации"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Источник питания"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["18-30 В постоянного тока"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Потребляемая мощность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["0,3 А макс"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Человеко-машинный интерфейс"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Визуализация SpectraNG-hmi на\nсенсорном экране, ПК, экране системы ЧПУ\n(например, Siemens 840D, Haidenhain, Fanuc, Indramat)"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Потребляемая мощность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["30 Вт"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

          
            
          ],
        },
      ],
    },
  }
  
];